import CustomRatingStar from '@public/icons/rating_star_new.svg';
import React, { SVGProps } from 'react';

type CustomRatingStarWrapperProps = SVGProps<SVGSVGElement>;
const CustomRatingStarWrapper: React.FC<CustomRatingStarWrapperProps> = (props) => {
  return <CustomRatingStar {...props} />;
};

export default CustomRatingStarWrapper;
